import React, { useState, useEffect } from 'react';
import { Box, TextField, Select, MenuItem, InputLabel, FormControl, IconButton, Snackbar, Alert, } from '@mui/material';
import { Dialog, DialogTitle, DialogContent, Table, TableBody, TableCell, TableRow, TableHead } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import Navbar from '../Navbar/Navbar';
import { useCarrito } from '../context/CarritoContext';
import { useMediaQuery } from '@mui/material';
import { useMemo } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import Cookies from 'js-cookie';
import { Switch, FormControlLabel } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';


const Inventario = () => {
  const [rows, setRows] = useState([]);
  const isMobile = useMediaQuery('(max-width:600px)');
  const PrecioHankook = Cookies.get('PrecioHankook');
  const [modalOpen, setModalOpen] = useState(false);
  const [detalleInventario, setDetalleInventario] = useState([]);
  const [productoSeleccionado, setProductoSeleccionado] = useState(null);
  const [soloDisponibles, setSoloDisponibles] = useState(false);
  const [modalPreciosListaOpen, setModalPreciosListaOpen] = useState(false);
  const [productoPreciosLista, setProductoPreciosLista] = useState(null);
  const [marcasDisponibles, setMarcasDisponibles] = useState([]);
  const OtrasMarcas = Cookies.get('OtrasMarcas');
  const VerSucursales = Cookies.get('VerSucursales');
  const IdUsuario = Cookies.get('IdUsuario');
  const [sucursalesPermitidas, setSucursalesPermitidas] = useState([]);
  const [modalNegarOpen, setModalNegarOpen] = useState(false);
  const [productoANegar, setProductoANegar] = useState(null);
  const [cantidadNegada, setCantidadNegada] = useState(1);

  const mapa_sucursales = {
    "ALMACEN AJUSTES": 1,
    "BODEGA CALVILLO": 2,
    "BODEGA DURANGO": 3,
    "BODEGA RINCON": 4,
    "CEDIS GUADALAJARA": 5,
    "CENTRO CAMIONERO": 6,
    "SUC GUADALAJARA": 7,
    "SUC LEON": 8,
    "SUC ZACATECAS": 9,
    "SUC PUERTO VALLARTA": 10
  };

  const [filters, setFilters] = useState({
    marca: '',
    ancho: '',
    alto: '',
    rin: '',
    MSPN: '',
    sucursalId: '',
    gama: '',
  });

  const [alerta, setAlerta] = useState({
    open: false,
    mensaje: '',
    tipo: 'success',
  });

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const { agregarAlCarrito } = useCarrito();

  useEffect(() => {
    const cargarInventario = () => {
      let url = 'https://bibliotecadlago.com/php/Backend/otramarca.php';
      if (OtrasMarcas === 1 || OtrasMarcas === '1') {
        url = 'https://bibliotecadlago.com/php/Backend/otramarca.php';
      }
      fetch(url)
        .then(res => res.json())
        .then(data => {
          if (data.success && Array.isArray(data.data)) {
            const productosConId = data.data.map((item, index) => ({
              ...item,
              id: index + 1
            }));
            setRows(productosConId);

            const marcasDisponibles = [
              ...new Set(productosConId.map(producto => producto.marca))
            ];
            setMarcasDisponibles(marcasDisponibles);
          } else {
            console.error("Respuesta inválida de la API");
          }
        })
        .catch(err => {
          console.error("Error al obtener inventario:", err);
        });
    };

    const cargarSucursalesPermitidas = () => {
      if (!IdUsuario) return;

      fetch('https://bibliotecadlago.com/php/sucursales.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ idUsuario: parseInt(IdUsuario, 10) })
      })
        .then(res => res.json())
        .then(data => {
          if (Array.isArray(data.SucursalesPermitidas)) {
            setSucursalesPermitidas(data.SucursalesPermitidas);
          } else {
            console.error("No se pudieron obtener sucursales permitidas");
          }
        })
        .catch(err => {
          console.error("Error al obtener sucursales permitidas:", err);
        });
    };

    cargarSucursalesPermitidas();
    cargarInventario();

    const intervalo = setInterval(() => {
      cargarInventario();
    }, 600000); // 600000 ms = 10 minutos

    return () => clearInterval(intervalo);

  }, [OtrasMarcas, IdUsuario]);

  const sucursalSeleccionadaNombre = Object.entries(mapa_sucursales).find(([nombre, id]) => id === Number(filters.sucursalId))?.[0];

  const filteredRows = rows.filter((row) => {
    const existeEnSucursal =
      !filters.sucursalId ||
      (row.inventario_detalle && row.inventario_detalle.some(detalle =>
        detalle.sucursal === sucursalSeleccionadaNombre && detalle.cantidad > 0
      ));

    return (
      (!filters.marca || row.marca === filters.marca) &&
      (!filters.ancho || row.ancho.toString() === filters.ancho) &&
      (!filters.alto || row.alto.toString() === filters.alto) &&
      (!filters.rin || row.rin.toString() === filters.rin) &&
      (!filters.MSPN || row.MSPN.toLowerCase().includes(filters.MSPN.toLowerCase())) &&
      (!soloDisponibles || Number(row.existencias) > 0) &&
      (!filters.gama || row.gama === filters.gama) &&
      existeEnSucursal
    );
  });

  const labelMap = {
    "20mas": "Mayoreo 20 y mas",
    "6a12": "Mayoreo 6-12 llantas",
    "13a19": "Mayoreo 13-19 llantas",
    "publico": "Precio Público",
    "lista": "Precio de Lista",
    "credito": "Precio Crédito",
    "contado": "Precio Contado",
    "mayoreo": "Precio Mayoreo",
    "mich28": "PLNA Michelin Lista 28 Días",
    "mich40": "PLNA Michelin Lista 40 Días",
    "michpremiun": "PLNA Michelin Lista Premium",
    "michroja": "PLNA Michelin Lista Roja",
    "michlisa": "PLNA Michelin Precio de Lista",
    "bf28": "PLNA BFGoodrich Lista 28 Días",
    "bf40": "PLNA BFGoodrich Lista 40 Días",
    "bfpremiun": "PLNA BFGoodrich Lista Premium",
    "bfroja": "PLNA BFGoodrich Lista Roja",
    "bflista": "PLNA BFGoodrich Precio de Lista",
    "uni28": "PLNA Uniroyal Lista 28 Días",
    "uni40": "PLNA Uniroyal Lista 40 Días",
    "unipremium": "PLNA Uniroyal Lista Premium",
    "uniroja": "PLNA Uniroyal Lista Roja",
    "unilista": "PLNA Uniroyal Precio de Lista",
    "proca": "PROCESS A",
    "procb": "PROCESS B",
    "revendedora": "Lista Venta Mayoreo Revendedor Columna A",
    "revendedorb": "Lista Venta Mayoreo Revendedor Columna B",
    "usuarioa": "Lista Venta Mayoreo Usuario Columna A",
    "usuariob": "Lista Venta Mayoreo Usuario Columna B",
    "50mas": "Mayoreo 50 y mas",
    "mostradorefec": "Lista Venta Mostrador-Pago Efectivo/TD/TC 1 exhibición",
    "mostrador12": "Lista Venta Mostrador-Pago TC 12 meses",
    "mostrador6": "Lista Venta Mostrador-Pago TC 6 meses",
    "mostradorameri": "Lista Venta Mostrador-Pago TC American Express",
    "unipremiumtcar": "Uniroyal-TCAR-Lista Premium",
    "ColumnaA": "Lista Venta Mayoreo ABC-Columna A",
    "ColumnaB": "Lista Venta Mayoreo ABC-Columna B",
    "ColumnaC": "Lista Venta Mayoreo ABC-Columna C",
    "PrecioBase": "Lista Venta Mayoreo ABC-Columna Precio Base",
    "Especial1": "Lista Venta Mayoreo Especial 1",
    "Especial2": "Lista Venta Mayoreo Especial 2",
    "Especial3": "Lista Venta Mayoreo Especial 3",
    "Especial4": "Lista Venta Mayoreo Especial 4",
    "usuarioc": "Lista Venta Mayoreo Usuario Columna C",
    "venmayoreo": "Lista Venta Mayoreo",
    "michpremiuntcar": "Michelin-TCAR-Lista Premium"
  };

  const handleNegarProducto = (producto) => {
    setProductoANegar(producto);
    setCantidadNegada(1);
    setModalNegarOpen(true);
  };

  const columns = useMemo(() => {
    const handleAgregarAlCarrito = (producto) => {
      agregarAlCarrito(producto);
      setAlerta({
        open: true,
        mensaje: `Agregado ${producto.descripcion} al carrito`,
        tipo: 'success',
      });
    };
    return [
      {
        field: 'MSPN',
        headerName: 'MSPN',
        width: isMobile ? 100 : 100,
        renderCell: (params) => {
          const estatus = params.row.estatus;
          const descuento = params.row.descuento;
          let textColor = '#000';

          if (estatus === 'ACTIVO') {
            textColor = '#242c59';
          } else if (estatus === 'DESCONTINUADO') {
            textColor = '#ff6600';
          }

          return (
            <span style={{ color: textColor, fontWeight: 'bold' }}>
              {params.value}
            </span>
          );
        }
      },
      {
        field: 'descripcion',
        headerName: 'Descripción',
        width: isMobile ? 500 : 500,
        renderCell: (params) => {
          const descripcion = params.row.descripcion;
          const mspn = params.row.MSPN;
          const precio = Number(params.row.precio).toLocaleString('es-MX', {
            style: 'currency',
            currency: 'MXN',
          });

          const textoACopiar = `MSPN: ${mspn}\n Descripción: ${descripcion}\nPrecio: ${precio}`;

          return (
            <Box display="flex" alignItems="center">
              <span style={{ marginRight: 8 }}>{descripcion}</span>
              <IconButton
                onClick={() => copiarAlPortapapeles(textoACopiar)}
                size="small"
                sx={{ color: '#9c27b0' }}
              >
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Box>
          );
        }
      },

      !isMobile && { field: 'ancho', headerName: 'Ancho', width: 90 },
      !isMobile && { field: 'alto', headerName: 'Alto', width: 90 },
      !isMobile && { field: 'rin', headerName: 'Rin', width: 80 },
      {
        field: 'precio',
        headerName: 'Precio Lista',
        width: isMobile ? 100 : 120,
        renderCell: (params) => {
          const valorNumerico = Number(params.value);
          return (
            <Box
              onClick={() => handleAbrirPreciosLista(params.row)}
              sx={{
                cursor: 'pointer',
                color: '#d32f2f',
                fontWeight: 'bold',
              }}
            >
              ${valorNumerico.toLocaleString('es-MX', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
            </Box>
          );
        }
      },


      {
        field: 'existencias',
        headerName: 'Existencias',
        width: isMobile ? 80 : 100,
        renderCell: (params) => {
          const detalle = params.row.inventario_detalle || [];
          const cantidadSucursal = filters.sucursalId
            ? detalle.find(item => item.sucursal === sucursalSeleccionadaNombre)?.cantidad || 0
            : params.row.existencias;

          return <span>{cantidadSucursal}</span>;
        }
      },
      {
        field: 'agregar',
        headerName: '',
        width: isMobile ? 200 : 200,
        renderCell: (params) => (
          <>
            <IconButton
              onClick={() => handleAgregarAlCarrito(params.row)}
              sx={{ color: '#cf1316' }}
              disabled={params.row.existencias === 0}
            >
              <AddIcon />
            </IconButton>
            <IconButton
              onClick={() => handleAbrirModal(params.row)}
              sx={{ color: '#1976d2' }}
            >
              <InfoIcon />
            </IconButton>
            <IconButton
              onClick={() => handleNegarProducto(params.row)}
              sx={{ color: '#ff1744', ml: 1 }}
            >
              <BlockIcon />
            </IconButton>
          </>

        ),
      },
    ].filter(Boolean); // quita los campos falsos si es móvil
  }, [isMobile, agregarAlCarrito, handleNegarProducto,]);

  const handleAbrirModal = (producto) => {
    setProductoSeleccionado(producto);
    setDetalleInventario(producto.inventario_detalle || []); // o busca por MSPN si la info no viene ya
    setModalOpen(true);
  };

  const handleAbrirPreciosLista = async (producto) => {
    try {
      const response = await fetch('https://bibliotecadlago.com/php/Backend/precioMayoreo.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ mspn: producto.MSPN }),
      });

      const result = await response.json();

      if (result.success && Array.isArray(result.data) && result.data.length > 0) {
        setProductoPreciosLista(result.data[0]);
        setModalPreciosListaOpen(true);
      } else {
        setAlerta({
          open: true,
          mensaje: 'No se encontraron precios para este producto.',
          tipo: 'info',
        });
      }
    } catch (error) {
      console.error('Error al obtener precios lista:', error);
      setAlerta({
        open: true,
        mensaje: 'Error al consultar precios.',
        tipo: 'error',
      });
    }
  };

  const mostrarPrecioHankook = productoPreciosLista?.marca?.toUpperCase() === 'HANKOOK' && PrecioHankook;

  const filasPrecios = mostrarPrecioHankook
    ? [
      ['Lista', productoPreciosLista?.Lista],
      [PrecioHankook, productoPreciosLista?.[PrecioHankook]],
    ]
    : Object.keys(labelMap).map((key) => [key, productoPreciosLista?.[key]]);

  const gamasDisponibles = useMemo(() => {
    if (!filters.marca) {
      return [...new Set(rows.map(row => row.gama).filter(Boolean))];
    }
    return [...new Set(
      rows
        .filter(row => row.marca === filters.marca)
        .map(row => row.gama)
        .filter(Boolean)
    )];
  }, [filters.marca, rows]);

  useEffect(() => {
    if (filters.gama && !gamasDisponibles.includes(filters.gama)) {
      setFilters(prev => ({ ...prev, gama: '' }));
    }
  }, [filters.marca, gamasDisponibles]);

  const sucursalesAMostrar = VerSucursales === '0'
    ? Object.entries(mapa_sucursales).filter(([nombre, id]) =>
      sucursalesPermitidas.includes(nombre)
    )
    : Object.entries(mapa_sucursales);



  const copiarAlPortapapeles = (texto) => {
    navigator.clipboard.writeText(texto).then(() => {
      setAlerta({
        open: true,
        mensaje: 'Copiado al portapapeles',
        tipo: 'success',
      });
    }).catch((err) => {
      setAlerta({
        open: true,
        mensaje: 'Error al copiar',
        tipo: 'error',
      });
      console.error('Error al copiar al portapapeles: ', err);
    });
  };

    const confirmarNegacion = async () => {
    if (!cantidadNegada || cantidadNegada <= 0 || !Number.isInteger(Number(cantidadNegada))) {
      setAlerta({
        open: true,
        mensaje: 'Ingresa una cantidad válida (entero positivo).',
        tipo: 'warning',
      });
      return;
    }

    try {
      const response = await fetch('https://bibliotecadlago.com/php/Backend/negar_producto.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          MSPN: productoANegar.MSPN,
          idUsuario: parseInt(IdUsuario, 10),
          cantidad: parseInt(cantidadNegada, 10),
        })
      });

      const data = await response.json();

      if (data.success) {
        setAlerta({
          open: true,
          mensaje: `Producto ${productoANegar.MSPN} negado con cantidad: ${cantidadNegada}`,
          tipo: 'success',
        });
      } else {
        throw new Error(data.message || 'Error al negar producto');
      }
    } catch (error) {
      console.error('Error al negar producto:', error);
      setAlerta({
        open: true,
        mensaje: 'Hubo un error al marcar como negado.',
        tipo: 'error',
      });
    }

    setModalNegarOpen(false);
  };

  return (
    <>
      <Navbar />
      <Box p={2}>
        <h2>Filtros</h2>
        <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'flex-start', sm: 'center' }} mb={2} >
        <FormControl sx={{ width: { xs: '80%', sm: '30%' }, mb: { xs: 2, sm: 0 }, }} >
          <InputLabel>Marca</InputLabel>
          <Select
            name="marca"
            value={filters.marca}
            onChange={handleFilterChange}
            label="Marca"
          >
            <MenuItem value="">Todas</MenuItem>
            {marcasDisponibles.map((marca) => (
              <MenuItem key={marca} value={marca}>
                {marca}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ width: { xs: '80%', sm: '30%' }, mb: { xs: 2, sm: 0 }, ml: { xs: 0, sm: 2 }, }} >
          <InputLabel>Gama</InputLabel>
          <Select
            name="gama"
            value={filters.gama}
            onChange={handleFilterChange}
            label="Gama"
          >
            <MenuItem value="">Todas</MenuItem>
            {gamasDisponibles.map((gama, index) => (
              <MenuItem key={index} value={gama}>{gama}</MenuItem>
            ))}
          </Select>
        </FormControl>
                  {!isMobile && (
            <Box sx={{ ml: 2 }}>
              <p style={{ fontSize: '14px', color: '#555', fontStyle: 'italic', margin: 0 }}>
                Todos los precios mostrados son antes de IVA
              </p>
            </Box>
          )}
        </Box>
        <Box display="flex" gap={2} flexWrap="wrap" mb={2}>
          <TextField label="Ancho" name="ancho" value={filters.ancho} onChange={handleFilterChange} />
          <TextField label="Alto" name="alto" value={filters.alto} onChange={handleFilterChange} />
          <TextField label="Rin" name="rin" value={filters.rin} onChange={handleFilterChange} />
        </Box>

        <TextField
          label="MSPN"
          name="MSPN"
          value={filters.MSPN}
          onChange={handleFilterChange}
          width={'100%'}
          sx={{ mb: 3 }}
        />

        <FormControlLabel
          control={
            <Switch
              checked={soloDisponibles}
              onChange={(e) => setSoloDisponibles(e.target.checked)}
            />
          }
          label="Solo disponibles"
          sx={{ ml: 2 }}
        />

        <FormControl sx={{ width: '80%', mb: 2 }}>
          <InputLabel>Sucursal</InputLabel>
          <Select
            name="sucursalId"
            value={filters.sucursalId}
            onChange={handleFilterChange}
            label="Sucursal"
          >
            <MenuItem value="">Todas</MenuItem>
            {sucursalesAMostrar.map(([nombre, id]) => (
              <MenuItem key={id} value={id}>{nombre}</MenuItem>
            ))}
          </Select>
        </FormControl>


        <Box display="flex" alignItems="center" gap={2} mb={2} mt={1}>
          <Box display="flex" alignItems="center" gap={1}>
            <Box sx={{ width: 20, height: 20, backgroundColor: '#242c59', borderRadius: '4px' }} />
            <span>Activo</span>
          </Box>
          <Box display="flex" alignItems="center" gap={1}>
            <Box sx={{ width: 20, height: 20, backgroundColor: '#ff6600', borderRadius: '4px' }} />
            <span>Hasta agotar existencias</span>
          </Box>
        </Box>
        <Box display="flex" alignItems="center" gap={1} mb={2}>
          <BlockIcon sx={{ color: '#ff1744' }} />
          <span style={{ fontSize: '14px' }}>
            Si no hay existencia, marcalo como <strong>negado</strong> para solicitar más.
          </span>
        </Box>
        <Box display="flex" alignItems="center" gap={1} mb={2}>
          {isMobile && <p style={{ fontSize: '16px', color: '#555', fontStyle: 'italic' }}> Todos los precios mostrados son antes de IVA </p>}
        </Box>
        <DataGrid
          rows={filteredRows}
          columns={columns}
          autoHeight
          pageSize={5}
          rowsPerPageOptions={[5, 10]}
        />
      </Box>

      <Snackbar
        open={alerta.open}
        autoHideDuration={1000}
        onClose={() => setAlerta({ ...alerta, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setAlerta({ ...alerta, open: false })}
          severity={alerta.tipo}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {alerta.mensaje}
        </Alert>
      </Snackbar>
      <Dialog open={modalOpen} onClose={() => setModalOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>
          Inventario por sucursal - {productoSeleccionado?.MSPN}
        </DialogTitle>
        <DialogContent>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sucursal</TableCell>
                <TableCell>Cantidad</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {detalleInventario
                .filter(item =>
                  Number(item.cantidad) > 0 &&
                  (
                    !filters.sucursalId || item.sucursal === sucursalSeleccionadaNombre
                  ) &&
                  (
                    sucursalesPermitidas.length === 0 ||
                    sucursalesPermitidas.includes(item.sucursal)
                  )
                )

                .map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{item.sucursal}</TableCell>
                    <TableCell>{item.cantidad}</TableCell>
                  </TableRow>
                ))}
              {VerSucursales === '0' && detalleInventario.some(item =>
                Number(item.cantidad) > 0 &&
                !sucursalesPermitidas.includes(item.sucursal)
              )}
            </TableBody>
          </Table>
        </DialogContent>
      </Dialog>
      <Dialog open={modalPreciosListaOpen} onClose={() => setModalPreciosListaOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>
          📋 Precios Mayoreo - {productoPreciosLista?.MSPN}
        </DialogTitle>
        <DialogContent dividers>
          <p><strong>Descripción:</strong> {productoPreciosLista?.descripcion}</p>
          <p>Todos los precios mostrados son antes de IVA</p>
          <Table>
            <TableBody>
              {filasPrecios
                .filter(([_, value]) => {
                  const num = Number(value);
                  return value !== undefined && value !== null && value !== '' && !isNaN(num) && num !== 0;
                })
                .map(([key, value], idx) => (
                  <TableRow key={idx}>
                    <TableCell><strong>{labelMap[key] || key}</strong></TableCell>
                    <TableCell>
                      {`$${Number(value).toLocaleString('es-MX', { minimumFractionDigits: 2 })}`}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>

          </Table>
        </DialogContent>
      </Dialog>
      <Dialog open={modalNegarOpen} onClose={() => setModalNegarOpen(false)} fullWidth maxWidth="xs">
        <DialogTitle>🚫 Producto no encontrado</DialogTitle>
        <DialogContent>
          <p><strong>MSPN:</strong> {productoANegar?.MSPN}</p>
          <p><strong>Descripción:</strong> {productoANegar?.descripcion}</p>
          <TextField
            label="Cantidad no encontrada"
            type="number"
            fullWidth
            inputProps={{ min: 1, step: 1 }}
            value={cantidadNegada}
            onChange={(e) => {
              const val = e.target.value;
              if (/^\d*$/.test(val)) {
                setCantidadNegada(val);
              }
            }}
            sx={{ mt: 2 }}
          />
          <Box display="flex" justifyContent="flex-end" mt={2}>
            <IconButton
              onClick={confirmarNegacion}
              color="error"
              variant="contained"
              sx={{ px: 2 }}
            >
              <BlockIcon />
              <span style={{ marginLeft: 8 }}>Solicitar</span>
            </IconButton>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Inventario;
